<template>
  <v-dialog
    scrollable
    v-model="isModalVisible"
    :max-width="maxWidth ?? 560"
    :persistent="isPersistent"
    v-bind="$attrs"
  >
    <TableCard :loading="isModalBodyLoading" :isDisabled="isModalBodyDisabled">
      <!-- Header -->

      <template v-if="isHeaderVisible">
        <v-toolbar color="transparent" density="comfortable" flat>
          <slot name="modal-header">
            <v-toolbar-title class="text-h5 font-weight-bold" data-test-id="global-modal-title">
              {{ title }}
            </v-toolbar-title>
          </slot>

          <v-spacer />

          <v-btn
            icon="mdi-close"
            data-test-id="global-modal-close-cta"
            variant="text"
            aria-label="Close dialog"
            @click="closeDialog"
          />
        </v-toolbar>

        <v-divider />
      </template>

      <!-- Body -->
      <v-card-text class="py-6">
        <slot name="modal-body" />
      </v-card-text>

      <template v-if="isFooterVisible">
        <v-divider />

        <!-- Footer -->
        <v-card-actions class="pa-4">
          <slot name="modal-actions-left" />

          <v-spacer />

          <slot name="modal-actions" />
        </v-card-actions>
      </template>
    </TableCard>
  </v-dialog>
</template>

<script lang="ts" setup>
import TableCard from '@/components/common/table-card/TableCard.vue';

type Props = {
  title?: string;
  maxWidth?: number;
  isPersistent?: boolean;
  isFooterVisible?: boolean;
  isHeaderVisible?: boolean;
  isModalBodyLoading?: boolean;
  isModalBodyDisabled?: boolean;
};

type Slots = {
  'modal-header': [];
  'modal-body': [];
  'modal-actions-left': [];
  'modal-actions': [];
};

defineSlots<Slots>();

withDefaults(defineProps<Props>(), {
  isPersistent: true,
  isFooterVisible: true,
  isHeaderVisible: true,
});

const isModalVisible = defineModel<boolean>('isModalVisible');

const closeDialog = () => {
  isModalVisible.value = false;
};
</script>
